const CACHE_KEY = "gsm_offline_cache";

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeCache(cache) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
  } catch (e) {
    console.error("Failed to persist offline cache:", e);
  }
}

// Anchored allow-list of setup-data GETs worth keeping for offline viewing.
// Deliberately excludes /savedgames*, /events/upcoming, /coursedb/*,
// /courserequest/* etc. -- those are admin/lookup flows, not "round setup
// data", and caching them would just grow the cache with things nobody
// needs to view offline.
const CACHEABLE_GET_PATTERNS = [
  /^\/players$/,
  /^\/courses$/,
  /^\/courses\/\d+\/holes$/,
  /^\/teams$/,
  /^\/groups$/,
  /^\/events\/current$/,
  /^\/events\/\d+\/players$/,
  /^\/scores\/\d+$/,
];

export function isCacheableGet(url) {
  return typeof url === "string" && CACHEABLE_GET_PATTERNS.some(re => re.test(url));
}

export function hasCached(url) {
  return Object.prototype.hasOwnProperty.call(readCache(), url);
}

export function getCached(url) {
  const entry = readCache()[url];
  return entry ? entry.data : undefined;
}

export function setCached(url, data) {
  const cache = readCache();
  cache[url] = { data, ts: Date.now() };
  writeCache(cache);
}
